// prettier-ignore
window.Awtomic = window.Awtomic || {};
window.Awtomic.bundleMapping = {
  wineDrop: {
    7937219723363: { handle: "the-wine-drop-3-bottle", label: "3 Bottles" },
    7903918653539: { handle: "the-wine-drop-6-bottle", label: "6 Bottles" }
  },
  cabDrop: {
    7935507726435: { handle: "the-cab-drop-3-bottle", label: "3 Bottles" },
    7935508414563: { handle: "the-cab-drop-6-bottle", label: "6 Bottles" }
  },
  communityClub: {
    7935508971619: { handle: "community-club-4-bottle", label: "4 Bottles" },
    7935509299299: { handle: "community-club-6-bottle", label: "6 Bottles" }
  }
};

window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

const isCustomerPortal = window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=");
const isBaBPurchaseFlow = window.location.pathname.includes("/tools/bundle-subscriptions/bundle/");

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});

// Function to generate bottle switcher buttons HTML
const bottleSwitcherContainer = (option1, option2, activeId, isProductPage = false) => {
  const queryString = window.location.search;

  return [option1, option2]
    .map(({ id, handle, label }) => {
      const isActive = id === activeId;
      const baseUrl = isActive ? "#" : isProductPage ? `/products/${handle}` : `/tools/bundle-subscriptions/bundle/${id}`;
      const url = isActive ? "#" : `${baseUrl}${queryString}`;
      const activeClass = isActive ? " active" : "";

      return `<a href="${url}" class="bundle-bottle-btn${activeClass}" data-bundle-id="${id}">${label}</a>`;
    })
    .join("");
};

// Handle product pages
if (window.location.pathname.startsWith("/products/")) {
  const currentHandle = window.location.pathname.split("/products/")[1].split("?")[0];

  // Find the pair containing this handle
  for (const pairData of Object.values(window.Awtomic.bundleMapping)) {
    const entries = Object.entries(pairData);
    const matchingEntry = entries.find(([id, data]) => data.handle === currentHandle);

    if (matchingEntry) {
      const [option1, option2] = entries.map(([id, data]) => ({ id, ...data }));

      waitForElement(".bundle-bottle-switcher-container", (container) => {
        container.innerHTML = bottleSwitcherContainer(option1, option2, matchingEntry[0], true);
      });
      break;
    }
  }
}

if (isBaBPurchaseFlow) {
  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return { object: {}, queryString: "" };

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    // Create query string format
    const queryString = Object.entries(bundleSelectedProducts)
      .map(([id, quantity]) => `${id}=${quantity}`)
      .join("&");

    // Create full URL with query string
    const currentUrl = window.location.href;
    const separator = currentUrl.includes("?") ? "&" : "?";
    const fullUrl = queryString ? `${currentUrl}${separator}${queryString}` : currentUrl;

    return {
      object: { [babProductId]: bundleSelectedProducts },
      queryString: queryString,
      fullUrl: fullUrl
    };
  };

  // Handle BaB flow
  const bundleId = window.location.pathname.split("/").pop();
  document.body.classList.add(`awt-bundle-${bundleId}`);

  waitForElement(".bundle-container main", (mainElement) => {
    // Find the pair containing this bundleId
    for (const pairData of Object.values(window.Awtomic.bundleMapping)) {
      const entries = Object.entries(pairData);
      if (entries.some(([id]) => id === bundleId)) {
        const [option1, option2] = entries.map(([id, data]) => ({ id, ...data }));

        const buttonContainer = document.createElement("div");
        buttonContainer.className = "bundle-bottle-switcher";
        buttonContainer.innerHTML = bottleSwitcherContainer(option1, option2, bundleId, false);
        mainElement.parentElement.insertBefore(buttonContainer, mainElement);
        break;
      }
    }
  });

  //add new stepper above old stepper (currently hidden via css)
  waitForElement(".bundle-container", (stepper) => {
    const newStepper = `
    <div class="bundle-new-stepper-wrapper">
      
      <div class="bundle-new-stepper">
        <div>
          
          <h4>Step 1: Select Your Wines</h4>
          <p>Customize your shipment to fit your taste. Unlock FREE shipping with 6+ bottles!</p>
        </div>
   
        <div>
          
          <h4>Step 2: Confirm Your Shipment</h4>
          <p>Sit back and relax, we'll take care of the rest!</p>
        </div>
      </div>
    </div>
    `;
    stepper.insertAdjacentHTML("beforebegin", newStepper);

    document.querySelectorAll(".bundle-scrollable-section").forEach((section) => section.classList.remove("bundle-scrollable-section"));

    const completeScreen = document.querySelector(".bundleapp-modal__container--complete-screen");
    if (completeScreen) {
      completeScreen.classList.add("bundle-scrollable-section");
    }

    //hack every click of nav.bundle-section__nav > button
    document.querySelectorAll("nav.bundle-section__nav > button").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();

        const targetId = button.getAttribute("aria-controls");
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const scrollableElement = document.querySelector(".bundle-scrollable-section");
          setTimeout(() => {
            let offset = document.querySelector(".bundle-new-stepper-wrapper") ? document.querySelector(".bundle-new-stepper-wrapper").offsetHeight : 0;
            if (offset != 0) offset = offset + 50;
            scrollableElement.scrollTo({
              top: targetElement.offsetTop + offset + 20,
              behavior: "smooth"
            });
          }, 1);
        }
      });
    });

    //hide options container if no options (or only 1)
    waitForElement(".awtomatic-sizes-container", (sizesContainer) => {
      if (sizesContainer.children.length <= 1) {
        sizesContainer.style.display = "none";
      }
    });

    waitForElement(".awtomatic-plans-container", (plansContainer) => {
      if (plansContainer.children.length <= 1) {
        plansContainer.style.display = "none";

        const previousElement = plansContainer.previousElementSibling;
        if (previousElement && previousElement.tagName.toLowerCase() === "span" && previousElement.classList.contains("bundle-text--subheading")) {
          previousElement.style.display = "none";
        }
      }
    });
  });
}
